/* eslint-disable */
import * as THREE from 'three'
import { u149, d405 } from './h.js'
import n from './r1.js'
import h from './b.js'
import f from './deep5.js'

var r = function (e) {
  function c(e, t, n) {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, c);
    var i = u149
      , r = d405
      , o = new THREE.PlaneGeometry(n.w, n.h)
      , a = h.default.get("/images/" + t)
      , s = h.default.get("/images/" + e)
      , l = new THREE.ShaderMaterial({
        uniforms: {
          u_originalImage: {
            type: "t",
            value: s
          },
          u_mapImage: {
            type: "t",
            value: a
          },
          u_mouse: {
            type: "v2",
            value: {
              x: 0,
              y: 0
            }
          },
          u_offset: {
            type: "v2",
            value: {
              x: 440,
              y: 100
            }
          },
          u_resolution: {
            type: "v2",
            value: {
              x: window.w,
              y: window.h
            }
          },
          u_opacity: {
            type: "f",
            value: 0
          }
        },
        vertexShader: i,
        fragmentShader: r,
        transparent: !0,
        depthTest: !1
      })
      , u = function (e, t) {
        if (!e)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t
      }(this, (c.__proto__ || Object.getPrototypeOf(c)).call(this, o, l));
    return u.image = {
      width: n.w,
      height: n.h
    },
      u.mouseRatio = {
        x: 0,
        y: 0
      },
      u.nMouse = {
        x: 0,
        y: 0
      },
      u.noise = new f.default,
      u.perlin = {
        x: 0,
        y: 0
      },
      u.oPosition = {
        x: 440,
        y: 10
      },
      u.smoothOffset = {
        x: u.oPosition.x,
        y: u.oPosition.y
      },
      u.resize(),
      u
  }
  return function (e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }),
      t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
  }(c, THREE.Mesh),
    n(c, [{
      key: "render",
      value: function (e) {
        this.perlin.x += .0045,
          this.perlin.y += .0065,
          this.mouseRatio.x = window.mouse.x / this.image.width * 2 - 1,
          this.mouseRatio.y = window.mouse.y / this.image.height * 2 - 1,
          this.nMouse.x += .05 * (-.035 * this.mouseRatio.x - this.nMouse.x),
          this.nMouse.y += .05 * (-.035 * this.mouseRatio.y - this.nMouse.y),
          this.smoothOffset.x += .1 * (this.oPosition.x + (50 * this.noise.getVal(this.perlin.x) - 20) - this.smoothOffset.x),
          this.smoothOffset.y += .1 * (this.oPosition.y - 300 * e + (80 * this.noise.getVal(this.perlin.y) - 40) - this.smoothOffset.y),
          this.material.uniforms.u_offset.value = this.smoothOffset,
          this.material.uniforms.u_mouse.value = this.nMouse
      }
    }, {
      key: "display",
      value: function () {
        TweenMax.to(this.material.uniforms.u_opacity, 3, {
          value: 1,
          ease: Power2.easeOut
        })
      }
    }, {
      key: "hide",
      value: function () { }
    }, {
      key: "resize",
      value: function () {
        this.material.uniforms.u_resolution.value.x = window.w,
          this.material.uniforms.u_resolution.value.y = window.h
      }
    }, {
      key: "dispose",
      value: function () {
        TweenMax.killTweensOf(this.material.uniforms.u_opacity),
          this.noise.dispose(),
          this.noise = null,
          this.perlin = this.image = this.mouseRatio = this.nMouse = this.oPosition = this.smoothOffset = null,
          this.material.dispose(),
          this.geometry.dispose()
      }
    }]),
    c
}();
var t = { default: r }

export default t
